import { Stripe } from "@stripe/stripe-js";
import PaymentTokenType from "shared/enums/PaymentTokenType";
import { ApiAmount } from "shared/types/ApiAmount";
import { LogAnalyticsFunctionType } from "../../../apps/myExperience/context/analyticsWrapper/types";

export enum PaymentGatewayType {
  BRAINTREE = "BRAINTREE",
  STRIPE = "STRIPE"
}

export interface ApiPaymentInitTokenResponse {
  registrationParticipantId: string;
  initToken: string;
  tokenType: PaymentTokenType;
  isPaypalEnabled: boolean;
  deleteCardAllowed: boolean;
  threeDSecureEnabled: boolean;
  paymentGatewayType: PaymentGatewayType;
  publicKey?: string;
  paymentIntentId?: string;
  offlinePaymentNote?: string;
  offlinePaymentEnabled: boolean;
}

export enum PaymentError {
  COULD_NOT_INITIALIZE = "couldNotInitializePaymentService",
  COULD_NOT_GET_NONCE = "couldNotGetPaymentNonce"
}

export interface InitializePaymentInterface {
  apiPaymentInitToken: ApiPaymentInitTokenResponse;
  amountObj: ApiAmount;
  setDisplayLoader?: Function;
  setPayButtonDisabled: Function;
  setPaymentError: Function;
  setPaymentNonce: Function;
}

/** reducer related */

export enum Action {
  PAY_BUTTON_DISABLE = "PAY_BUTTON_DISABLE",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  DISPLAY_LOADER = "DISPLAY_LOADER"
}

export interface PaymentState {
  isPayButtonDisabled: boolean;
  paymentError?: string;
  displayLoader: boolean;
}

export type PaymentActionType =
  | { type: Action.PAY_BUTTON_DISABLE; payload: boolean }
  | { type: Action.PAYMENT_ERROR; payload: string }
  | { type: Action.DISPLAY_LOADER; payload: boolean };

export interface PaymentDispatchInterface {
  setIsPayButtonDisabled: (payload: boolean) => void;
  setPaymentError: (payload: string) => void;
  setDisplayLoader: (payload: boolean) => void;
}

export interface PaymentComponentProps {
  setPaymentNonce: Function;
  amountObj: ApiAmount;
  registrationParticipantId: string;
  showCardIcons?: boolean;
  purchaseOrderId: string;
  stripeReturnUrl?: string;
  errorHandler?: (err: any) => void;
  onAmountMismatch?: (e: any) => void;
  logPurchaseError?: LogAnalyticsFunctionType;
  onPurchaseOrderVerificationFailure?: () => void;
  invoicePayerId?: string;
  onTokenInitialised?: (data: ApiPaymentInitTokenResponse) => void;
  backToOfflineRequestedClickHandler?: () => void;
}

export interface PaymentServiceProps {
  amountObj: ApiAmount;
  setPaymentNonce: Function;
  registrationParticipantId: string;
  purchaseOrderId: string;
  stripeReturnUrl?: string;
  invoicePayerId?: string;
  errorHandler?: (err: any) => void;
  onTokenInitialised?: (data: ApiPaymentInitTokenResponse) => void;
}

export interface PaymentService {
  getTokenForPayment: () => void;
  retryGetTokenForPayment: () => void | undefined;
  isPayButtonDisabled: boolean;
  displayLoader: boolean;
  paymentGatewayType?: PaymentGatewayType;
  stripePromise?: Promise<Stripe | null>;
  apiPaymentInitToken?: ApiPaymentInitTokenResponse;
  setDisplayLoader: (showLoader: any) => void;
  setPayButtonDisabled: (isButtonDisabled: any) => void;
  getNewInitToken: () => void;
}

export interface StripeComponentProps {
  service: PaymentService;
  stripeReturnUrl?: string;
  registrationParticipantId: string;
  purchaseOrderId: string;
  onAmountMismatch?: (e: any) => void;
  amountObj: ApiAmount;
  logPurchaseError?: LogAnalyticsFunctionType;
  setPaymentNonce: Function;
  invoicePayerId?: string;
  onPurchaseOrderVerificationFailure?: () => void;
  backToOfflineRequestedClickHandler?: () => void;
}

export interface StripeCheckoutFormProps {
  setPayButtonDisabled: (val: boolean) => void;
  setDisplayLoader: (val: boolean) => void;
  isPayButtonDisabled: boolean;
  stripeReturnUrl?: string;
  registrationParticipantId: string;
  purchaseOrderId: string;
  getNewInitToken: () => void;
  onAmountMismatch?: (e: any) => void;
  amountObj: ApiAmount;
  initToken?: string;
  logPurchaseError?: LogAnalyticsFunctionType;
  setPaymentNonce: Function;
  invoicePayerId?: string;
  onPurchaseOrderVerificationFailure?: () => void;
  backToOfflineRequestedClickHandler?: () => void;
}
